import React, { PureComponent } from 'react'
import "./style.scss";
import { Empty } from "@ss/mtd-react3";
import LoginInternal from "@/components/login-internal";



export default class index extends PureComponent {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
    }

    render() {
        return (
            <div className="market-guideline-page">
                <LoginInternal appendPath="/market-guideline" />
            </div>
        )
    }
}
